import {
  AssignmentDetailsData,
  ChangeSet,
  ChangeSetItemKey
} from 'modules/assignment-details';
import { TranslationKey } from 'modules/i18n';
import { AssignmentChangeStatus } from 'modules/status-badge';
import {
  DEFAULT_TIMEZONE,
  getHoursAndMinutesLabel,
  getShortDateLabelWithTimezone
} from 'utils/date';
import { ModifiedChangeSetData } from './types';

export const MAP_CHANGES_INFO_TEXT: Record<
  AssignmentChangeStatus,
  TranslationKey
> = {
  [AssignmentChangeStatus.APPLIED]: 'assignmentDetailsPage.changesApplied',
  [AssignmentChangeStatus.NOT_APPLIED]: 'assignmentDetailsPage.upcomingChanges'
};

export const MAP_CHANGESET_KEYS: Partial<
  Record<ChangeSetItemKey, TranslationKey>
> = {
  location: 'assignmentDetailsPage.location',
  startDate: 'assignmentDetailsPage.startDate',
  endDate: 'assignmentDetailsPage.endDate',
  expectedPeriodMinutes: 'assignmentDetailsPage.weeklyHours'
};

export const transformChangeSetItemValue = (
  key: ChangeSetItemKey,
  value: AssignmentDetailsData[ChangeSetItemKey]
) => {
  if (key === 'location' && typeof value === 'string') return value;

  if ((key === 'startDate' || key === 'endDate') && typeof value === 'string')
    return getShortDateLabelWithTimezone(value, DEFAULT_TIMEZONE);

  if (key === 'expectedPeriodMinutes' && typeof value === 'number')
    return getHoursAndMinutesLabel(value);

  return '';
};

export const prepareChangeSetData = (
  changeSet: ChangeSet
): ModifiedChangeSetData[] => {
  return Object.entries(changeSet).map(([key, value]) => {
    return {
      label: MAP_CHANGESET_KEYS[key as ChangeSetItemKey] ?? '',
      value: transformChangeSetItemValue(key as ChangeSetItemKey, value)
    };
  });
};
